import request from './request'

const LOGIN_TIMEOUT_MS = 15000

export const authApi = {
  login(formData) {
    return request.post('/api/v1/user_service/auth/login', formData, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      timeout: LOGIN_TIMEOUT_MS
    })
  },
  register(data) {
    return request.post('/api/v1/user_service/auth/register', data)
  }
}
